export enum UserType {
  OP_CO = 'op_co',
  ORGANIZATION = 'organization',
}
